import React, { Component } from 'react'
import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/material';

/**
 * Informacion básica del alumno
 */
export default class SkeletonAlumno extends Component {

  /**
   * Render
   *
   * @returns {Component}
   */
  render() {

    return (
        <Grid container spacing={2} mt={2}>
            <Grid item xs={2}>
                <Skeleton variant="rounded" width={"80%"} height={"100%"}/>
            </Grid>
            <Grid item xs={8}>
                <Skeleton variant="text" sx={{ fontSize: '2.5em' }} width={"20%"}/>
                <Skeleton variant="text" sx={{ fontSize: '2em' }}   width={"30%"}/>
                <Skeleton variant="text" sx={{ fontSize: '1em' }}   width={"30%"}/>
                <Skeleton variant="text" sx={{ fontSize: '1em' }}   width={"30%"}/>
            </Grid>
            <Grid item xs={2} justifyContent={"end"}>
                <Skeleton variant="rounded" width={"50%"} height={40}/>
            </Grid>

            <Grid container item mt={5}>
                <Grid item xs={12}>
                    <Skeleton variant="text" sx={{ fontSize: '2em' }} width={"20%"}/>
                </Grid>
            </Grid>

            <Grid container item mt={5}>
                <Grid item xs={3}>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </Grid>

                <Grid item xs={3}>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </Grid>

                <Grid item xs={3}>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </Grid>

                <Grid item xs={3}>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                    <Skeleton variant="text" sx={{ fontSize: '1em' }} width={"90%"}/>
                </Grid>
            </Grid>
        </Grid>
    )
  }
}
